export var generateSteps = function (data, xScale, yScale, labelSelector, keyName) {
    var steps = [];
    data.forEach(function (_d, index) {
        var _a;
        var value = (_a = data[index]) === null || _a === void 0 ? void 0 : _a[keyName];
        var range = yScale.range();
        var width = 20;
        var lastTick = yScale.ticks()[yScale.ticks().length - 1];
        var x = xScale(data[index][labelSelector]) - width / 2;
        if (keyName !== labelSelector && value) {
            var step = {
                key: index + "." + keyName + ".step",
                selector: [index, keyName],
                x: x,
                y: yScale(lastTick),
                height: range[0] - range[1],
                width: width,
                middle: x + width / x,
            };
            steps.push(step);
        }
    });
    return steps;
};
